import { useAPI } from "@/services/api";
import { SignupRequest } from "@/services/apiTypes";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { MutationButton } from "@Light/components/page/MutationButton";
import { PageBody } from "@Light/components/page/PageBody";
import { Input } from "@Light/components/system/Input";
import { useMutation } from "@Light/utils/mutation";
import { useForm, useWatch } from "react-hook-form";
import { Navigate, useSearchParams } from "react-router-dom";

export type SignupProps = {};

export const Signup: React.FC<SignupProps> = ({}) => {
  const [searchParams] = useSearchParams();
  const plan = searchParams.get("plan") ?? null;
  const { useSignupMutation } = useAPI();
  const signup = useMutation<SignupRequest>(useSignupMutation);
  const { register, handleSubmit, control } = useForm<{ email: string }>();
  const email = useWatch({ control, name: "email" });
  const mutate = handleSubmit(({ email }) => {
    signup.mutate({
      email,
      plan,
    });
  });
  if (signup.isSuccess) {
    const searchParams = new URLSearchParams({
      email: email ?? "",
    });
    if (plan) {
      searchParams.set("plan", plan);
    }
    return <Navigate to={`/shop/email-sent?${searchParams}`} />;
  }
  return (
    <form onSubmit={mutate}>
      <PageBody
        footerAfterContent={true}
        title="What is your email address?"
        subtitle="Before we can walk you through the plan enrollment, we need to verify your email address."
        footer={
          <ButtonFooter>
            <MutationButton
              size="lg"
              mutateButtonText="Submit"
              mutation={signup}
              mutate={mutate}
              errorMessage="Failed selecting the plan. Please try again later."
            />
          </ButtonFooter>
        }
      >
        <Input
          type="email"
          placeholder="Email"
          {...register("email", { required: true })}
        />
      </PageBody>
    </form>
  );
};
